// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"61":"96e34522","535":"07919d30","894":"13def85d"}[chunkId] + ".js";
};